export default "../media/email_icon.23cc857d5fa14107c836519886205f7f.svg";